import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  BooleanInput,
  DateTimeInput,
  required,
  minValue,
} from "react-admin";

const subscriptionStatuses = [
  { id: "active", name: "Активна" },
  { id: "expired", name: "Истекла" },
  { id: "cancelled", name: "Отменена" },
  { id: "suspended", name: "Приостановлена" },
  { id: "pending", name: "Ожидает" },
];

const currencies = [
  { id: "USD", name: "USD" },
  { id: "EUR", name: "EUR" },
  { id: "RUB", name: "RUB" },
];

export const UserSubscriptionCreate = () => {
  return (
    <Create title="Создать подписку пользователя">
      <SimpleForm>
        <TextInput
          source="userId"
          label="ID пользователя"
          validate={[required()]}
          fullWidth
        />
        <ReferenceInput
          source="subscriptionPlanId"
          reference="subscriptionPlans"
          label="План подписки"
        >
          <SelectInput optionText="name" validate={[required()]} fullWidth />
        </ReferenceInput>
        <SelectInput
          source="status"
          label="Статус"
          choices={subscriptionStatuses}
          validate={[required()]}
          defaultValue="active"
        />
        <DateTimeInput
          source="startDate"
          label="Дата начала"
          validate={[required()]}
        />
        <DateTimeInput
          source="endDate"
          label="Дата окончания"
          validate={[required()]}
        />
        <NumberInput
          source="amountPaid"
          label="Сумма оплаты"
          validate={[minValue(0)]}
          step={0.01}
        />
        <SelectInput
          source="currency"
          label="Валюта"
          choices={currencies}
          defaultValue="USD"
        />
        <TextInput
          source="paymentTransactionId"
          label="ID транзакции"
          fullWidth
        />
        <BooleanInput
          source="autoRenew"
          label="Автопродление"
          defaultValue={false}
        />
      </SimpleForm>
    </Create>
  );
};
